import { render, staticRenderFns } from "./QuickActionContainer.vue?vue&type=template&id=22540d5f&scoped=true"
import script from "./QuickActionContainer.vue?vue&type=script&lang=js"
export * from "./QuickActionContainer.vue?vue&type=script&lang=js"
import "./QuickActionContainer.vue?vue&type=style&index=0&id=22540d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22540d5f",
  null
  
)

export default component.exports